<template>
  <div>
    <v-navigation-drawer
      app
      clipped
      temporary
      v-model="drawer">
      <v-list two-line dense>
        <v-list-tile>
          <v-list-tile-content>
            <v-list-tile-title>Welcome {{ name }}</v-list-tile-title>
            <small v-if="hasLocation">from {{ location.Name }}</small>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile v-if="canAdmin" to="/style-guide" exact>
          <v-list-tile-action>
            <v-icon>line_style</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              Style Guide
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile v-if="canAdmin" to="/administration" exact>
          <v-list-tile-action>
            <v-icon>settings</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              Administration
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile v-if="canEmployee" to="/clients" exact>
          <v-list-tile-action>
            <v-icon>person</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              Clients
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile v-if="canEmployee" to="/dashboard" exact>
          <v-list-tile-action>
            <v-icon>view_module</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              Dashboard
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile v-if="canTech" to="/tech" exact>
          <v-list-tile-action>
            <v-icon>content_cut</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              Tech
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile v-if="canTech" to="/tech/profile" exact>
          <v-list-tile-action>
            <v-icon>pie_chart</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              Tech Profile
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile v-if="canCheckIn" to="/check/in">
          <v-list-tile-action>
            <v-icon>check</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              Check In
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar
      v-if="showNavigation"
      color="primary"
      dark
      app
      clipped-left
      fixed>
      <v-toolbar-title :style="$vuetify.breakpoint.smAndUp ? 'width: 400px; min-width: 250px' : 'min-width: 72px'" class="ml-0 pl-3">
        <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
        <span class="hidden-xs-only">Page Name Here</span>
      </v-toolbar-title>
      <div class="d-flex align-center" style="margin-left: auto">
        <v-menu offset-y>
          <v-btn dark flat slot="activator">
            <span v-if="hasLocation">{{ location.Name }}</span> <v-icon>more_vert</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile>
              <v-list-tile-title>
                Switch Location
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="logout">
              <v-list-tile-title>
                Log Off
              </v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </div>
    </v-toolbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data: () => ({
    drawer: false
  }),
  computed: {
    ...mapGetters({
      canAdmin: 'user/canAdmin',
      canCheckIn: 'user/canCheckIn',
      canEmployee: 'user/canEmployee',
      canTech: 'user/canTech',
      hasLocation: 'user/hasLocation',
      isLoggedIn: 'user/isLoggedIn',
      location: 'user/getLocation',
      name: 'user/getName',
      getShowNavigation: 'route/getShowNavigation'
    }),
    showNavigation () {
      return this.isLoggedIn && this.getShowNavigation
    }
  },
  created () {
    // console.log('HEADER', 'TODO: create menu to change location')
  },
  methods: {
    logout () {
      this.$store.dispatch('user/logout')
    }
  }
}
</script>

<style lang="scss">
.toolbar__title {
  span {
    letter-spacing: 0.3em;
    text-transform: uppercase;
  }
}
</style>
